import { gql } from '@apollo/client/core'

import { PAGE_INFO_ATTRIBUTES } from './fragments'

const PAGINATED_PRODUCT_INSTANCE_BOOKINGS_QUERY = gql`
  query productInstanceBookings(
    $projectId: ID
    $query: String
    $first: Int
    $last: Int
    $offset: Int
    $after: String
    $before: String
  ) {
    productInstanceBookings(
      projectId: $projectId
      query: $query
      first: $first
      last: $last
      offset: $offset
      after: $after
      before: $before
    ) {
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
      nodes {
        id
        startDate
        returnDate
        bookingType
        name
        serialNumber
      }
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
`

export { PAGINATED_PRODUCT_INSTANCE_BOOKINGS_QUERY }
